<div class="container-fluid px-0 bg-star">
    <div class="container py-5">
    <div class="row">
        <div class="col-md-6 m-auto">
            <div class="box-design with-before">
                <div class="content-section">
                    <h5 class="mb-4">Payment Cancelled</h5>
                    <p>
                        Hey, You have cancelled your payment please start over again to purchase a subscription.
                    </p>
                </div>
            </div>
        </div>
    </div>

</div>
</div>